import React from 'react';
import { Button, IconButton, TextField } from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

export class AppointmentTemplates extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            org: props.org
        }
    }

    render() {
        const { onChange } = this.props;
        const { org } = this.state;

        let appointmentTemplates = [];
        if (org.config['appointmentMessageTemplates']) {
            try {
                appointmentTemplates = JSON.parse(org.config['appointmentMessageTemplates'] || "[]")
            } catch (err) {
                console.error("addPatientTerms parse error:", err);
                appointmentTemplates = [];
            }
        }

        const onUpdateOrg = (org) => {
            if (appointmentTemplates.length > 0) {
                org.config['appointmentMessageTemplates'] = JSON.stringify(appointmentTemplates);
            } else {
                delete org.config['appointmentMessageTemplates'];
            }
            this.setState({ org }, () => {
                if (onChange) onChange(org)
            })
        }

        return <div>
            <table>
                <tbody>
                    {appointmentTemplates.map((template, i) => {
                        return <tr>
                            <td valign='top'>
                                <IconButton style={{ margin: 5 }} onClick={() => {
                                    appointmentTemplates.splice(i, 1);
                                    onUpdateOrg(org);
                                }}><DeleteIcon /></IconButton>
                            </td>
                            <td valign='top'>
                                <TextField style={{ margin: 5, width: 200 }} label='Template ID' value={template.templateId} onChange={(e) => {
                                    template.templateId = e.target.value;
                                    onUpdateOrg(org);
                                }} />
                                <TextField style={{ margin: 5, width: 100 }} type='number' label='Order' value={template.order} onChange={(e) => {
                                    template.order = e.target.value;
                                    onUpdateOrg(org);
                                }} />
                                <TextField style={{ margin: 5, width: 200 }} label='Label' value={template.label} onChange={(e) => {
                                    template.label = e.target.value;
                                    onUpdateOrg(org);
                                }} />
                            </td>
                            <td valign='top'>
                                <TextField variant='outlined' style={{ margin: 5, width: 600 }} multiline={true} minRows={5} maxRows={5} label='Text' value={template.text} onChange={(e) => {
                                    template.text = e.target.value;
                                    onUpdateOrg(org);
                                }} />
                            </td>
                        </tr>
                    })}
                </tbody>
            </table>
            <br />
            <Button size='small' startIcon={<AddIcon />} style={{ margin: 5 }} onClick={(e) => {
                appointmentTemplates.push({ templateId: '', label: '', text: '', order: 0 });
                onUpdateOrg(org);
            }}>Add Template</Button>
        </div>
    }
}